const state = {
	socketStatus: false,
	socketToken:'',
	lastTime:0,//最后一次响应心跳时间
	sendTime:0,//发送心跳时间
}
const mutations = {
	// 更新socket 连接状态
	UPDATE_SOCKET_STATUS(state, status) {
	  state.socketStatus = status
	},
	// 更新socket token
	UPDATE_SOCKET_TOKEM(state,token) {
		state.socketToken = token
	},
	UPDATE_SOCKET_LASTTIME(state,time) {
		state.lastTime = time
	},
	UPDATE_SOCKET_SENDTIME(state,time) {
		state.sendTime = time
	}
}
const actions = {
	
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
}